import C from "../actionTypes";

const initialMemberDetails = {};

export const currentMemberDetails = (state = initialMemberDetails, action) => {
  switch (action.type) {
    case C.AGENT_DETAILS_SUCCESS:
      return action.data;
    case C.AGENT_DETAILS_FAILURE:
      return initialMemberDetails;
    default:
      return state;
  }
}